import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
    outer: {
        overflow: 'hidden',
        '& > table': {
            transform: props => `translateX(-${props.translate}px)`,
        },
    },
}));

export default useStyles;
